import * as React from 'react';
import { Route, Redirect, RouteProps } from 'react-router';

export type AuthCheck = () => boolean;

type AuthRouteProps = {
  component: any;
  authCheck: AuthCheck;
  redirectTo: string;
} & RouteProps;

export default class AuthRoute extends React.Component<AuthRouteProps> {
  render() {
    var { component: Component, authCheck, redirectTo, ...rest } = this.props;
    var authenticated = authCheck();
    return (
      <Route
        {...rest}
        render={(props) => {
          return authenticated ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: this.props.redirectTo,
                state: { from: props.location },
              }}
            />
          );
        }}
      />
    );
  }
}
